<script>
  import model from "../../stores/modelStore";
  import { projectSettings } from "../../config";
  import { registerFormStart } from "../../tealium";

  import PageSection from "../../components/PageSection.svelte";
  import Form from "../../components/Form.svelte";
  import FormRow from "../../components/FormRow.svelte";
  import FormColumn from "../../components/FormColumn.svelte";
  import ClassActionEmailAddress from "../../components/ClassActionEmailAddress.svelte";
  import ClassActionPhoneNumber from "../../components/ClassActionPhoneNumber.svelte";
  import NavigationButtons from "../../components/NavigationButtons.svelte";
  import Checkbox from "../../components/Checkbox.svelte";

  export let title = null;
  export let pageTitle = null;
  export let lastVisitedPage = null;
  export let disabled = null;

  let buttons;

  if (!disabled) {
    $model.lastPageVisited = lastVisitedPage;
    document.title = pageTitle;

    //  Get the user Agent
    $model.userAgent = navigator.userAgent;
    $model.referrer = document.referrer;
    $model.registrationSegmentId = null;
  }
</script>

<PageSection>
  <FormRow class="justify-content-center confirmation-hide">
    <FormColumn>
      <h1 class="text-center">{@html projectSettings.classActionName}</h1>
      <h2 class="text-center">REGISTRATION CLOSED</h2>
    </FormColumn>
  </FormRow>

  <FormRow class="justify-content-md-center confirmation-hide">
    <FormColumn>
      <p>Registration for this class action has now closed.</p>
      <p>
        The settlement administration is now underway, and the Court-appointed
        Scheme Administrators are Grant Thornton.
      </p>
      <p>
        Grant Thornton will communicate directly with group members to provide
        further information about next steps, including group members' potential
        eligibility to receive compensation.
      </p>
      <p>
        Please direct any questions regarding the class action or settlement
        administration process to the Scheme Administrators via email at
        <a
          href="mailto:Stolenwages.wa@au.gt.com"
          title="Email Stolenwages.wa@au.gt.com">Stolenwages.wa@au.gt.com</a
        >
        or phone at
        <a href="tel:(08) 9480 2005" title="Telephone (08) 9480 2005"
          >(08) 9480 2005</a
        >
      </p>
      <p>
        For more information please visit
        <a href="https://www.stolenwageswa.com.au/" title="WA Stolen Wages"
          >https://www.stolenwageswa.com.au/</a
        >.
      </p>
    </FormColumn>
  </FormRow>
</PageSection>

<style>
  h1 {
    margin-bottom: 20px;
  }
  h2 {
    margin-bottom: 16px;
  }
</style>
